import PropTypes from "prop-types";
import { htmlSanitize } from "app/utils/sanitize";
import { useTemplateRender, useTemplateRenderToString } from "app/utils/hooks/useTemplateRender";
import "./paragraphs.scss";

const Paragraphs = ({ paragraphs = [], enableHTMLFormatting = false }) => {
	const templateRender = useTemplateRender();
	const templateRenderToString = useTemplateRenderToString();

	if (Array.isArray(paragraphs)) {
		const paragraphNodes = paragraphs.map((paragraph, index) => {
			if (enableHTMLFormatting === true) {
				return (
					<article
						className="paragraphs__item"
						key={index}
						dangerouslySetInnerHTML={{
							__html: htmlSanitize(templateRenderToString(paragraph)),
						}}
					/>
				);
			}
			return (
				<article className="paragraphs__item" key={index}>
					{templateRender(paragraph)}
				</article>
			);
		});
		return <section className="paragraphs">{paragraphNodes}</section>;
	}
	return (
		<section
			className="paragraphs"
			dangerouslySetInnerHTML={{
				__html: htmlSanitize(templateRenderToString(paragraphs)),
			}}
		/>
	);
};

Paragraphs.propTypes = {
	paragraphs: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
	enableHTMLFormatting: PropTypes.bool,
};

export default Paragraphs;
